import { BaseModal, ModalResultType, ModalOptions, ModalColor } from "../../../core/modal/index";
import { Template, LazyTemplate } from "../../../core/template/index";
import BBPlugin from "../../../core/bbclient/plugin";
import BBrowser from "../../../core/bbclient/browser";
import MessageModal from "../../../core/modals/message";
import FortumDatabase from "../../db";
import KeyCode from "../../../core/helpers/keycode";
import { BarcodeAuthentication } from "../../../core/app";
import { FortumApp } from "../../fortumApp";

export default class BarcodeAuthenticationModal extends BaseModal
{
    public template = Template.lazy('/app/modals/barcode-authentication/index.html', true);
    public data: ModalOptions & {
        personNumberAuthenticationErrorMessage: string,
        personNumber: string,
    };

    private personNumberField: HTMLInputElement;
    private form: HTMLFormElement;

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Authentication'),
        }
    }

    public beforeRender(): PromiseLike<void> {
        return super.beforeRender();
    }

    public afterRender() {
        return super.afterRender().then(() => {
            const onScannerButtonDown = (e: KeyboardEvent) => {
                if (e.keyCode == KeyCode.F9 || e.keyCode == KeyCode.F10 || e.keyCode == KeyCode.F11 || e.keyCode == 139 || e.keyCode == 140 || e.keyCode == 141) {
                    this.personNumberField.focus();
                }
            };
            
            if (BBrowser.isAvailable() && BBrowser.hasPlugin('general')) {
                let bbGeneral = BBrowser.plugin('general');

                bbGeneral.on('onKeyEvent', onScannerButtonDown); 
                bbGeneral.call('listenKeyEvents', {handleEvents: false}); 
                console.info('Listening Bluugo Browser "onKeyEvent" event.');
            } else {
                window.addEventListener('keydown', onScannerButtonDown);
                console.info('Listening native "keydown" event.');
            }
        });
    }

    public onOkButtonClick(e: MouseEvent) {
        this.close(ModalResultType.OK);
    }

    public onLogoutButtonClick() {
        localStorage.removeItem('barcode-authentication');
        location.reload();
    }

    public onLogoutDataAuthentication() {
        this.app.logout();
    }

    
    private barcodeScanner: {
        isAvailable: boolean,
        instance: BBPlugin,
    } = {
        isAvailable: false,
        instance: null,
    };

    async submit() {
        const db = this.app.db as FortumDatabase;
        const customer = await db.Customer.filter(c => c.number == this.data.personNumber).first();
        if (customer) {
            if (!customer.user_account_id) {
                this.data.personNumberAuthenticationErrorMessage = this.pgettext(
                    'barcode-authentication',
                    'User {username} ({person_number}) does not have an account on Tracking Cloud. Please make sure the user has an account, synchronize the device and try again.',
                    {person_number: customer.number, username: `${customer.first_name} ${customer.last_name}`}
                );
            } else {
                const account = await db.UserAccount.where('id').equals(customer.user_account_id).first();
                const user = await db.User.where('id').equals(account.user_id).first();
                this.data.personNumberAuthenticationErrorMessage = '';
                (this.app as FortumApp).writeBarcodeAuthentication({customer, user, account});
                await this.close();
                location.reload();
            }
        } else {
            this.data.personNumberAuthenticationErrorMessage = this.pgettext(
                'barcode-authentication', 
                'The person number "{person_number}" does not exist. Please synchronize the device and try again.',
                {person_number: this.data.personNumber}
            );
        }
    }

}